@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.error-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon {
  fill: @settings-page--stores-selected-checkout--error--fill-color;
  height: 110px;
  width: 110px;
}

.message {
  font-size: 16px;
  color: @settings-page--stores-selected-checkout--error--text-color;
  margin-top: 20px;
}
